import {
  Dashboard,
  MainAccount,
  ManageMainAccount,
  IncomingTransaction,
  OutgoingTransaction,
  ViewTransaction,
  ViewUserTransaction,
  withType,
  History,
  Profile,
  ChangePassword,
  RegistrationStep,
  ReInstall,
  TotalAccount,
  AccountDetail,
  MobileUser,
  MobileUserSearch,
  DesktopUser,
  KeyRecoveryRequests,
  CustomerInfo,
  MobileCustomerInfo,
  WaitingForApproveMobile,
  WaitingForApproveDesktop,
  DesktopLimit,
  MobileLimit,
  AddLimit,
  EditLimit,
  TermsAndConditionsMobile,
  TermsAndConditionsDesktop,
  ManageAuthorizers,
  BankInfo,
  ChangePhoneRequests,
  RecoveryRequests,
  MerchantDetails,
  Merchants,
  MerchantRequests,
  MerchantRequestDetails,
  Roles,
  Permissions,
  Endpoints,
  Users,
  BlankPage,
} from "./views";

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config

// Page that include in Menu, Header, Footer
const routes = [
  // Keyholder registration
  {
    path: "/keyholder/registration",
    name: "Register Account",
    component: RegistrationStep,
  },
  {
    path: "/keyholder/re-install",
    name: "Re-Installation",
    component: ReInstall,
  },
  {
    path: "/blank-page",
    name: "Blank page",
    component: BlankPage,
  },

  // Dashboard
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/main_account",
    name: "Main Account",
    component: MainAccount,
  },
  {
    path: "/manage_main_account",
    name: "Manage Main Account",
    component: ManageMainAccount,
  },
  {
    path: "/total_account",
    name: "Total Account",
    component: TotalAccount,
  },
  {
    path: "/account_detail/:id",
    name: "Account Detail",
    component: AccountDetail,
  },
  {
    path: "/incoming_transactions",
    name: "Incoming Transactions",
    component: IncomingTransaction,
  },
  {
    path: "/outgoing_transactions",
    name: "Outgoing Transactions",
    component: OutgoingTransaction,
  },
  /*
   manual set route for account detail:
   this use to keep user not to confused.
  */
  {
    path: "/view_transaction/:id",
    name: "Account Detail",
    exact: true,
    component: AccountDetail,
  },
  {
    path: "/view_incoming_transaction/:accountId/:id",
    name: "View Incoming Transaction",
    component: withType("incoming")(ViewUserTransaction),
  },
  {
    path: "/view_outgoing_transaction/:accountId/:id",
    name: "View Outgoing Transaction",
    component: withType("outgoing")(ViewUserTransaction),
  },
  {
    path: "/view_transaction/:accountId/:id",
    name: "View Transaction",
    component: ViewTransaction,
  },
  {
    path: "/history",
    name: "History",
    component: History,
  },
  {
    path: "/auditor-history",
    name: "Auditor History",
    component: withType("auditor")(History),
  },
  {
    path: "/settings",
    exact: true,
    name: "Settings",
    component: Profile,
  },
  {
    path: "/settings/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/settings/change_password",
    name: "Change Password",
    component: ChangePassword,
  },
  {
    path: "/customer_kyc_info/:id",
    name: "Customer Information",
    component: CustomerInfo,
  },
  {
    path: "/kyc_info/:id",
    name: "Customer KYC Information",
    component: MobileCustomerInfo,
  },
  {
    path: "/auditor/kyc_info/:id",
    name: "Customer KYC Information",
    component: withType("auditor")(MobileCustomerInfo),
  },
  {
    path: "/change-phone-requests-admin",
    name: "Change Phone Requests Manager",
    component: withType("admin")(ChangePhoneRequests),
  },
  // Authorizer
  {
    path: "/change-phone-requests",
    name: "Change Phone Requests",
    component: withType("authorizer")(ChangePhoneRequests),
  },
  {
    path: "/recovery-requests",
    name: "Recovery requests",
    component: RecoveryRequests,
  },
  // Admin
  {
    path: "/waiting_for_approval",
    exact: true,
    name: "Waiting for Approval",
    component: WaitingForApproveMobile,
  },
  {
    path: "/waiting_for_approval/mobile",
    name: "Mobile requests",
    component: WaitingForApproveMobile,
  },
  {
    path: "/waiting_for_approval/desktop",
    name: "Desktop requests",
    component: WaitingForApproveDesktop,
  },
  {
    path: "/mobile-users",
    name: "Mobile Users",
    component: MobileUser,
  },
  {
    path: "/auditor-users",
    name: "Auditor Users",
    component: withType("auditor")(MobileUser),
  },
  {
    path: "/mobile-user-search",
    name: "Search mobile user",
    component: MobileUserSearch,
  },
  {
    path: "/desktop-users",
    name: "Desktop Users",
    component: DesktopUser,
  },
  {
    path: "/key_recovery_requests",
    name: "Key recovery requests list",
    component: KeyRecoveryRequests,
  },
  {
    path: "/manage_authorizers/:accountId",
    name: "Manage authorizers",
    component: ManageAuthorizers,
  },
  {
    path: "/view_bank_info",
    name: "Bank Contact Information",
    component: BankInfo,
  },
  // KYCLimitAmount
  {
    path: "/kyc-limit-amount/",
    exact: true,
    name: "User KYC Limit Amount",
    component: MobileLimit,
  },
  {
    path: "/kyc-limit-amount/mobile-limit",
    name: "Mobile Limits",
    component: MobileLimit,
  },
  {
    path: "/kyc-limit-amount/desktop-limit",
    name: "Desktop Limits",
    component: DesktopLimit,
  },
  {
    path: "/kyc-limit-edit/:limitId",
    name: "Edit limit",
    component: EditLimit,
  },
  {
    path: "/kyc-limit-add/",
    name: "Add limit",
    component: AddLimit,
  },
  {
    path: "/terms_and_conditions/mobile",
    name: "Terms and Conditions",
    component: TermsAndConditionsMobile,
  },
  {
    path: "/terms_and_conditions/desktop",
    name: "Terms and Conditions",
    component: TermsAndConditionsDesktop,
  },
  // Merchants
  {
    path: "/merchants",
    exact: true,
    name: "Merchants",
    component: Merchants,
  },
  {
    path: "/merchants/:id",
    name: "Merchant Details",
    component: MerchantDetails,
  },
  {
    path: "/merchant-requests",
    exact: true,
    name: "Merchant Requests",
    component: MerchantRequests,
  },
  {
    path: "/merchant-requests/:id",
    name: "Merchant Request Details",
    component: MerchantRequestDetails,
  },
  // Roles
  {
    path: "/roles",
    exact: true,
    name: "Roles",
    component: Roles,
  },
  {
    path: "/endpoints",
    exact: true,
    name: "Endpoints",
    component: Endpoints,
  },
  {
    path: "/pages",
    exact: true,
    name: "Pages",
    component: Permissions,
  },
  {
    path: "/users",
    exact: true,
    name: "Users",
    component: Users,
  },
];

export default routes;
